import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { checkAuthCookies } from '../../utils/auth';

/**
 * Hook to enforce authentication on protected routes.
 * Redirects to login page (/) with "after" and "signup" parameters if user doesn't have valid auth cookies.
 * Returns true if authenticated, false otherwise.
 */
export const useRequireAuth = (): boolean => {
  const navigate = useNavigate();
  const location = useLocation();
  const isAuthenticated = checkAuthCookies();

  useEffect(() => {
    if (!isAuthenticated) {
      const currentPath = location.pathname + location.search + location.hash;
      const isLoginPage = location.pathname === '/';
      navigate(isLoginPage ? `/` : `/?after=${encodeURIComponent(currentPath)}&signup=false`, {
        replace: true,
      });
    }
  }, [isAuthenticated, navigate, location]);

  return isAuthenticated;
};
